import * as React from 'react';
import { Article } from '../../Model/core';
import { Loading } from '../Loading';

export interface SearchResultState {
};
export interface SearchResultProps {
    items: Article[];
    loading: boolean;
}

export class SearchResult extends React.Component<SearchResultProps, SearchResultState>{
    constructor(props: SearchResultProps) {
        super(props);

        this.state = { items: [] };
    }

    render() {
        const { items, loading } = this.props;
        if (items.length === 0 && !loading) {
            return null;
        }
        return (
            <>
                <div className='row pt-5 pb-5'>
                    <div className='col-12'>
                        <span><h2>Sökresultat</h2></span>
                    </div>
                    <Loading loading={loading} />
                </div>
                <div className='row'>
                    {items.map((article) => <SingleResult
                        key={article.PageId}
                        article={article}
                    />)}
                </div>
            </>
        );
    }
}


type SingleResultProps = { article: Article };
const SingleResult = ({ article }: SingleResultProps) => {
    return (
        <div className='mb-5 col-xl-3 col-md-4 col-12'>
            <div className='card' style={{ minHeight: 250 }}>
                <a href={`__${article.PageId}`} title={article.Title}>
                    <img src={article.ImageUrl} />
                </a>

                <div className='card-body p-0'>
                    <span className='card-published pt-3 pb-2'>{article.Published}</span>
                    <h5 className='card-title'>
                        <a href={`__${article.PageId}`} title={article.Title}>{article.Title}</a>
                    </h5>
                    <p className='card-text'>{article.Description}</p>
                    <a href={`__${article.PageId}`} title={article.Title}>Läs mer »</a>
                </div>
            </div>
        </div>
    );
};